import { useState, useEffect } from 'react';

/**
 * Hook genérico para suscribirse al estado de una cola (baseQueue)
 *
 * @param {Object} queueInstance - Instancia de cola creada con createBaseQueue
 * @returns {Object} Estado de la cola
 */
function useQueue(queueInstance) {
  const [state, setState] = useState(queueInstance.getState());

  useEffect(() => {
    return queueInstance.subscribe(setState);
  }, [queueInstance]);

  return state;
}

export default useQueue;
